module.exports = __webpack_public_path__ + "static/tile-smart-phone-mobile-apps-digital-cb913dec0e4dda5f0315868972c19f3b.jpg";